// @internal
import './number-operations';
import { CustomSelection } from './globals.d';

window.saveSelection = function (containerEl: HTMLElement, wnd: Window | undefined): CustomSelection | null
{
	if (!wnd)
	{
		wnd = window;
	}

	let sel = wnd.getSelection();

	if (sel !== null)
	{
		let range = sel.getRangeAt(0);
		let preSelectionRange = range.cloneRange();

		preSelectionRange.selectNodeContents(containerEl);
		preSelectionRange.setEnd(range.startContainer, range.startOffset);

		let start = preSelectionRange.toString().length;

		return {
			start: start,
			end: start + range.toString().length
		};
	}
	else
	{
		return null;
	}
};

window.restoreSelection = function (containerEl: HTMLElement, savedSel: CustomSelection, wnd: Window | undefined): void
{
	if (!wnd)
	{
		wnd = window;
	}

	let charIndex = 0;
	let range = wnd.document.createRange();

	range.setStart(containerEl, 0);
	range.collapse(true);

	let nodeStack = [containerEl];
	let node;
	let foundStart = false;
	let stop = false;
	let nextCharIndex;

	while (!stop && (node = nodeStack.pop()))
	{
		if (node.nodeType == 3)
		{
			nextCharIndex = charIndex + (node as any).length;

			if (!foundStart && savedSel.start >= charIndex && savedSel.start <= nextCharIndex)
			{
				range.setStart(node, savedSel.start - charIndex);

				foundStart = true;
			}

			if (foundStart && savedSel.end >= charIndex && savedSel.end <= nextCharIndex)
			{
				range.setEnd(node, savedSel.end - charIndex);
				stop = true;
			}

			charIndex = nextCharIndex;
		}
		else
		{
			let i = node.childNodes.length;

			while (i--)
			{
				nodeStack.push(node.childNodes[i] as HTMLElement);
			}
		}
	}

	let sel = wnd.getSelection();

	if (sel !== null)
	{
		sel.removeAllRanges();
		sel.addRange(range);
	}
};